import React, { useState } from 'react'
import { FileUploader as FileUploaderComponents } from '~/src/components/molecules'

interface IUploadFile {
  onSaveFile: (file: File) => void
  onDeleteFile: () => void
  initFile?: {
    filename: string
    url: string
  }
  fileText: string
  uploadText: string
  isLoading: boolean
  isError: boolean
  optionWidth?: string
}

/**
 * FileUploader
 * @param onSaveFile
 * @param onDeleteFile
 * @param initFile
 * @param fileText
 * @param uploadText
 * @param isLoading
 * @param isError
 * @param optionWidth
 * @constructor
 */
export const FileUploader: React.FC<IUploadFile> = ({
  onSaveFile,
  onDeleteFile,
  initFile,
  fileText,
  uploadText,
  isLoading,
  isError,
  optionWidth,
}) => {
  const [image, setImage] = useState<string>(initFile?.url ?? '')
  const [file, setFile] = useState<string>(initFile?.filename ?? '')
  /**
   * handleFileChange
   * @param e
   */
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return
    setImage(URL.createObjectURL(e.target.files[0]))
    setFile(e.target.files[0].name)
    onSaveFile(e.target.files[0])
    e.target.value = ''
  }
  /**
   * handleClearImage
   */
  const handleClearImage = () => {
    setImage('')
    setFile('')
    onDeleteFile()
  }

  return (
    <FileUploaderComponents
      file={file}
      image={image}
      fileText={fileText}
      uploadText={uploadText}
      isLoading={isLoading}
      isError={isError}
      handleFileChange={handleFileChange}
      handleDelete={handleClearImage}
      optionWidth={optionWidth}
    />
  )
}
